import { render, staticRenderFns } from "./List.vue?vue&type=template&id=08e25c8c&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/jqwidgets/jqx.base.css?vue&type=style&index=0&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports